<script>
export default {
  name: "StudentWritingSubmission",
  props: {
    currenMarkingData: {
      type: Object,
      default: null
    },
  },
  computed: {
    firstImage() {
      if (Array.isArray(this.currenMarkingData?.userAnswer) && this.currenMarkingData?.userAnswer?.length > 0 &&
          typeof this.currenMarkingData?.userAnswer[0] === 'string' &&
          this.currenMarkingData?.userAnswer[0].includes('https') ){
        return this.currenMarkingData?.userAnswer[0]
      }
      return ''
    },
    userAnswer() {
      if (Array.isArray(this.currenMarkingData?.userAnswer)){
       return  this.currenMarkingData?.userAnswer[0]
      }
      return this.currenMarkingData?.userAnswer
    },
    wordCount() {
      if (!this.userAnswer || typeof this.userAnswer !== 'string') return 0
      const plainText = this.userAnswer.replace(/<[^>]*>/g, '').trim()
      if (!plainText) return 0
      return plainText.split(/\s+/).filter(w => w.length > 0).length
    }
  }
}
</script>

<template>
  <div class="w-100">
    <div style="display: flex; align-items: center; gap: 10px; margin-bottom: 10px">
      <p style="font-size: 16px; font-weight: bold; margin-bottom: 0">Bài làm của học viên</p>
      <span v-if="!firstImage && wordCount > 0" style="background-color: #409EFF; color: white; padding: 2px 8px; border-radius: 10px; font-size: 12px; font-weight: 600">
        {{ wordCount }} từ
      </span>
    </div>
    <div style="background-color: #F8F8F8" class="p-5">
      <p id="midterm-test" v-html="currenMarkingData?.question"></p>
      <div v-if="currenMarkingData?.image" class="mb-5">
        <el-image
            :key="currenMarkingData.image"
            style="width: 100px; height: 100px"
            :src="currenMarkingData.image"
            :preview-src-list="[currenMarkingData.image]">
        </el-image>
      </div>
      <div style="background-color: white ; text-align: justify" class="p-5">
        <el-image
            v-if="firstImage"
            :key="firstImage"
            style="width: 100px; height: 100px"
            :src="firstImage"
            :preview-src-list="currenMarkingData?.userAnswer">
        </el-image>
        <p v-else>{{ userAnswer ??'Học viên không nộp bài'}}</p>
      </div>
    </div>
  </div>
</template>

<style>
#midterm-test ol {
  list-style: none;
  padding-left: 0; /* bỏ khoảng thụt mặc định */
}
</style>